import React, { createContext, useState } from "react";
import axios from "axios";
export const AuthContext = createContext();
export const base_url = process.env.REACT_APP_API_URL;
export const app_url = process.env.REACT_APP_APP_URL;
export const app_name = process.env.REACT_APP_APP_NAME;
// Share text for Telegram. Telegram shows the app link (url) first, then this text.
const shareText = (reffercode) =>
    `नमस्कार दोस्तों,  इस एप्लीकेशन में आपको जो सबसे ज्यादा रेट मिलता है ₹10 के 970 और सबसे ज्यादा टाइमिंग।
and support https://user.${app_url}
मोबाइल एप्लीकेशन लिंक ये ऊपर है, इस लिंक पर क्लिक करके डाउनलोड करो 👆🏼👆🏼👆🏼👆🏼` +
    (reffercode ? `

रेफर कोड मांगे तो ये लगा देना: My Refer Code: ${reffercode}` : "");
// With a refer code the shared link opens login with the code pre-filled (/login?ref=CODE), same as the Refer page
const telegramShareUrl = (reffercode) => {
    const link = reffercode
        ? `${window.location.origin}/login?ref=${encodeURIComponent(reffercode)}`
        : `https://${app_url}`;
    return `https://t.me/share/url?url=${encodeURIComponent(link)}&text=${encodeURIComponent(shareText(reffercode))}`;
};
export const TelegramShareLink = telegramShareUrl();

// Own refer code, remembered so the share sheet can open synchronously on click
export const getSavedReferCode = () => {
    try {
        return localStorage.getItem("my_refer_code") || "";
    } catch (e) {
        return "";
    }
};
const saveReferCode = (code) => {
    try {
        if (code) localStorage.setItem("my_refer_code", code);
    } catch (e) {}
};

// Share the app anywhere (WhatsApp, Telegram, SMS...) through the phone's share sheet.
// Must be called directly inside a click handler. Falls back to Telegram share where the share sheet is unsupported.
export const shareApp = (reffercode) => {
    const url = reffercode
        ? `${window.location.origin}/login?ref=${encodeURIComponent(reffercode)}`
        : `https://${app_url}`;
    if (navigator.share) {
        navigator.share({ title: app_name, text: shareText(reffercode), url }).catch(() => {});
        return;
    }
    const telegramUrl = telegramShareUrl(reffercode);
    if (!window.open(telegramUrl, "_blank", "noopener,noreferrer")) {
        window.location.href = telegramUrl;
    }
};
// Default support chat when the admin has not set one
export const TelegramMessageSupport = "https://t.me/aghoricompany";

// Admin "Support App" setting (contact_info) -> { url, type }. The admin saves a full t.me or wa.me link;
// older values (@username, t.me/name, bare number) are still read as Telegram.
export const getSupportInfo = (contact) => {
  const value = String(contact || "").trim();
  if (!value) return { url: TelegramMessageSupport, type: "telegram" };
  const type = /wa\.me|whatsapp/i.test(value) ? "whatsapp" : "telegram";
  if (/^https?:\/\//i.test(value)) return { url: value, type };
  if (/^(t\.me|telegram\.me|wa\.me)\//i.test(value)) return { url: "https://" + value, type };
  if (/^\+?\d+$/.test(value)) return { url: "https://t.me/+" + value.replace("+", ""), type: "telegram" };
  return { url: "https://t.me/" + value.replace(/^@/, ""), type: "telegram" };
};
export const getTelegramLink = (contact) => getSupportInfo(contact).url;

// Support contact remembered from the last fetch, so the Support button works instantly
export const getSavedSupportContact = () => {
  try {
    return localStorage.getItem("support_contact") || "";
  } catch (e) {
    return "";
  }
};
export const saveSupportContact = (contact) => {
  try {
    localStorage.setItem("support_contact", contact || "");
  } catch (e) {}
};
// Footer Chat link, set separately by admin
export const getSavedChatContact = () => {
  try {
    return localStorage.getItem("chat_contact") || getSavedSupportContact();
  } catch (e) {
    return "";
  }
};
const saveChatContact = (contact) => {
  try {
    localStorage.setItem("chat_contact", contact || "");
  } catch (e) {}
};
export const AuthProvider = ({ children }) => {
  const loginstatus = localStorage.getItem("login");
  const TokenName = "90XBLACKDOG";
  const TokenVal = "08b657cc840fcbe8bb7d9ed4499ce18c";
  const [isAuthenticated, setIsAuthenticated] = useState(
    loginstatus && loginstatus !== "" ? true : false
  );

// Telegram share link with the user's refer code (used by the footer Share button)
const TelegramShareMessage = async () => {
    try {
        let data = new FormData();
        data.append(TokenName, TokenVal);
        data.append("user_id", loginstatus);

        // refer_info returns the user's own refer code (profile does not include my_reffer_code)
        const response = await axios({
            method: "POST",
            url: base_url + "Webservices/refer_info",
            data: data,
        });

        const reffercode = response.data && response.data.data ? response.data.data.refer_code : "";
        saveReferCode(reffercode);
        return telegramShareUrl(reffercode);
    } catch (error) {
        console.error("Error fetching data:", error);
        return null; // Return null in case of an error
    }
};



  const login = (datas, callback) => {
    let data = new FormData();
    data.append(TokenName, TokenVal);
    Object.entries(datas).forEach(([key, value]) => {
      data.append(key, value);
    });
    axios({
      method: "POST",
      url: base_url + "Webservices/login",
      data: data,
    })
      .then((response) => {
        if (
          response.data.status === 1 &&
          response.data.id &&
          response.data.id !== ""
        ) {
          localStorage.setItem("login", response.data.id);
          localStorage.removeItem("my_refer_code");
          setIsAuthenticated(true);
        }
        callback(response.data, true);
      })
      .catch((error) => {
        callback(error, false);
        console.error("Error fetching data:", error);
      });
  };
  const getMarkets = (callback) => {
    let data = new FormData();
    data.append(TokenName, TokenVal);
    axios({
      method: "POST",
      url: base_url + "Webservices/game_list",
      data: data,
    })
      .then((response) => {
        callback(response.data, true);
      })
      .catch((error) => {
        callback(error, false);
        console.error("Error fetching data:", error);
      });
  };
  const profile = (callback) => {
    let data = new FormData();
    data.append(TokenName, TokenVal);
    data.append("user_id", loginstatus);
    axios({
      method: "POST",
      url: base_url + "Webservices/profile",
      data: data,
    })
      .then((response) => {
        callback(response.data, true);
      })
      .catch((error) => {
        callback(error, false);
        console.error("Error fetching data:", error);
      });
  };
  const FSC_KEY_UPDATE = (token, callback) => {
    let data = new FormData();
    data.append(TokenName, TokenVal);
    data.append("user_id", loginstatus);
    data.append("token", token);
    axios({
      method: "POST",
      url: base_url + "Webservices/updatefcm",
      data: data,
    })
      .then((response) => {
        callback(response.data, true);
      })
      .catch((error) => {
        callback(error, false);
        console.error("Error fetching data:", error);
      });
  };
  const Gameinfo = (id, callback) => {
    let data = new FormData();
    data.append(TokenName, TokenVal);
    data.append("game_id", id);
    axios({
      method: "POST",
      url: base_url + "Webservices/game_details",
      data: data,
    })
      .then((response) => {
        callback(response.data, true);
      })
      .catch((error) => {
        callback(error, false);
        console.error("Error fetching data:", error);
      });
  };
  const GroupinfoDetail = (id, callback) => {
    let data = new FormData();
    data.append(TokenName, TokenVal);
    data.append("groupid", id);
    data.append("user_id", loginstatus);
    axios({
      method: "POST",
      url: base_url + "Webservices/group_details",
      data: data,
    })
      .then((response) => {
        callback(response.data, true);
      })
      .catch((error) => {
        callback(error, false);
        console.error("Error fetching data:", error);
      });
  };
  const GroupInitiateChat = (id,body, callback) => {
    let data = new FormData();
    data.append(TokenName, TokenVal);
    data.append("groupid", id);
    data.append("user_id", loginstatus);
    data.append("body", body);
    axios({
      method: "POST",
      url: base_url + "Webservices/group_initiate_chats",
      data: data,
    })
      .then((response) => {
        callback(response.data, true);
      })
      .catch((error) => {
        callback(error, false);
        console.error("Error fetching data:", error);
      });
  };
  const GroupChat = (id, callback) => {
    let data = new FormData();
    data.append(TokenName, TokenVal);
    data.append("groupid", id);
    data.append("user_id", loginstatus);
    axios({
      method: "POST",
      url: base_url + "Webservices/group_chats",
      data: data,
    })
      .then((response) => {
        callback(response.data, true);
      })
      .catch((error) => {
        callback(error, false);
        console.error("Error fetching data:", error);
      });
  };
  const Groupinfo = (callback) => {
    let data = new FormData();
    data.append(TokenName, TokenVal);
    data.append("user_id", loginstatus);
    axios({
      method: "POST",
      url: base_url + "Webservices/group_list",
      data: data,
    })
      .then((response) => {
        callback(response.data, true);
      })
      .catch((error) => {
        callback(error, false);
        console.error("Error fetching data:", error);
      });
  };
  const GroupAdd = (id,callback) => {
    let data = new FormData();
    data.append(TokenName, TokenVal);
    data.append("user_id", loginstatus);
    data.append("group_id", id);
    axios({
      method: "POST",
      url: base_url + "Webservices/group_add",
      data: data,
    })
      .then((response) => {
        callback(response.data, true);
      })
      .catch((error) => {
        callback(error, false);
        console.error("Error fetching data:", error);
      });
  };
  const Addbet = (id, type, arrval, grandTotal, callback) => {
    let data = new FormData();
    data.append(TokenName, TokenVal);
    data.append("user_id", loginstatus);
    data.append("game_id", id);
    data.append("game_type", type);
    data.append("bet_numbers", arrval);
    data.append("grand_total", grandTotal);

    axios({
      method: "POST",
      url: base_url + "Webservices/game_bet",
      data: data,
    })
      .then((response) => {
        callback(response.data, true);
      })
      .catch((error) => {
        callback(error, false);
        console.error("Error fetching data:", error);
      });
  };
  const CancelBet = (id, callback) => {
    let data = new FormData();
    data.append(TokenName, TokenVal);
    data.append("user_id", loginstatus);
    data.append("game_id", id);
    axios({
      method: "POST",
      url: base_url + "Webservices/game_bet_cancel",
      data: data,
    })
      .then((response) => {
        callback(response.data, true);
      })
      .catch((error) => {
        callback(error, false);
        console.error("Error fetching data:", error);
      });
  };
  const Transactiondata = (category, pageNo, callback) => {
    let data = new FormData();
    data.append(TokenName, TokenVal);
    data.append("user_id", loginstatus);
    let URL = "Webservices/transaction_history";
    if (category === "market" || category === "marketcancel") {
      URL = "Webservices/my_bets";
    }
    if (category === "marketcancel") {
      URL = "Webservices/my_bets_cancel";
    }
    axios({
      method: "POST",
      url: base_url + URL,
      data: data,
    })
      .then((response) => {
        callback(response.data, true);
      })
      .catch((error) => {
        callback(error, false);
        console.error("Error fetching data:", error);
      });
  };
  // Support contact set by admin (Webservices/help returns game_setting.contact_info); works without login
  const SupportContact = (callback) => {
    let data = new FormData();
    data.append(TokenName, TokenVal);
    axios({
      method: "POST",
      url: base_url + "Webservices/help",
      data: data,
    })
      .then((response) => {
        if (response.data && response.data.status === 1) {
          // data = Playground/Home link, chat = footer Chat link (older servers send only data)
          const chat = response.data.chat || response.data.data;
          saveSupportContact(response.data.data);
          saveChatContact(chat);
          callback(response.data.data, chat);
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  const ReferInfo = (callback) => {
    let data = new FormData();
    data.append(TokenName, TokenVal);
    data.append("user_id", loginstatus);
    axios({
      method: "POST",
      url: base_url + "Webservices/refer_info",
      data: data,
    })
      .then((response) => {
        callback(response.data, true);
      })
      .catch((error) => {
        callback(error, false);
        console.error("Error fetching data:", error);
      });
  };
  const GameRule = (callback) => {
    let data = new FormData();
    data.append(TokenName, TokenVal);
    data.append("user_id", loginstatus);
    axios({
      method: "POST",
      url: base_url + "Webservices/game_rule",
      data: data,
    })
      .then((response) => {
        callback(response.data, true);
      })
      .catch((error) => {
        callback(error, false);
        console.error("Error fetching data:", error);
      });
  };
  const AddMoney = (grandTotal, callback) => {
    let data = new FormData();
    data.append(TokenName, TokenVal);
    data.append("user_id", loginstatus);
    data.append("amount", grandTotal);
    axios({
      method: "POST",
      url: base_url + "Webservices/add_money_gateway",
      data: data,
    })
      .then((response) => {
        callback(response.data, true);
      })
      .catch((error) => {
        callback(error, false);
        console.error("Error fetching data:", error);
      });
  };
  const WithdrawMoney = (
    Amount,
    Password,
    BankCard,
    Account,
    Ifsc,
    AccountHolder,
    BankName,
    callback
  ) => {
    let data = new FormData();
    data.append(TokenName, TokenVal);
    data.append("user_id", loginstatus);
    data.append("amount", Amount);
    data.append("number", Password);
    data.append("type", BankCard);
    data.append("bank_ac_no", Account);
    data.append("ifsc_code", Ifsc);
    data.append("ac_holder_name", AccountHolder);
    data.append("bank_name", BankName);
    axios({
      method: "POST",
      url: base_url + "Webservices/withdraw_money",
      data: data,
    })
      .then((response) => {
        callback(response.data, true);
      })
      .catch((error) => {
        callback(error, false);
        console.error("Error fetching data:", error);
      });
  };
  const GameChart = (game_id, callback) => {
    let data = new FormData();
    data.append(TokenName, TokenVal);
    data.append("user_id", loginstatus);
    data.append("game_id", game_id);
    let URL = "Webservices/game_chart";
    axios({
      method: "POST",
      url: base_url + URL,
      data: data,
    })
      .then((response) => {
        callback(response.data, true);
      })
      .catch((error) => {
        callback(error, false);
        console.error("Error fetching data:", error);
      });
  };
  const PromotionData = (callback) => {
    axios
      .get(
        base_url + "api/promotion.php?action=getuserinfo&user=" + loginstatus,
        {
          headers: {
            Accept: "application/json",
          },
        }
      )
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  const BankCardData = (callback) => {
    axios
      .get(base_url + "api/bankcard.php?action=bankcard&user=" + loginstatus, {
        headers: {
          Accept: "application/json",
        },
      })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  const WithdrawalRequest = (data, callback) => {
    axios
      .post(
        base_url + "api/bankcard.php?action=withdrawal&user=" + loginstatus,
        data
      )
      .then((response) => {
        callback(response.data[0]);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  const AddBanksCard = (data, callback) => {
    axios
      .post(
        base_url + "api/game.php?action=addbankcard&user=" + loginstatus,
        data
      )
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const Gameresult = (gamename, callback) => {
    axios
      .get(
        base_url + "api/game.php?game=" + gamename + "&action=resultrec&page=1",
        {
          headers: {
            Accept: "application/json",
          },
        }
      )
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  const UserGameresult = (gamename, page, callback) => {
    axios
      .get(
        base_url +
          "api/game.php?game=" +
          gamename +
          "&action=betrec&page=" +
          page +
          "&user=" +
          loginstatus,
        {
          headers: {
            Accept: "application/json",
          },
        }
      )
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  const LevelDetail = (level, callback) => {
    axios
      .get(
        base_url +
          "api/game.php?level=" +
          level +
          "&action=inviterecord&page=1&user=" +
          loginstatus,
        {
          headers: {
            Accept: "application/json",
          },
        }
      )
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  const Bankdata = (callback) => {
    axios
      .get(base_url + "api/game.php?action=bankcard&user=" + loginstatus, {
        headers: {
          Accept: "application/json",
        },
      })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  const sendOTP = (mobile, callback) => {
    axios
      .get(base_url + "api/otp.php?num=" + mobile, {
        headers: {
          Accept: "application/json",
        },
      })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const P2PTransferAmount = (data, callback) => {
    axios
      .post(
        base_url + "api/game.php?action=p2ptransfer&user=" + loginstatus,
        data,
        {
          headers: {
            Accept: "application/json",
          },
        }
      )
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  const Register = (data, callback) => {
    axios
      .post(base_url + "api/auth.php?action=addusers", data, {
        headers: {
          Accept: "application/json",
        },
      })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  const ForgotPassword = (data, callback) => {
    axios
      .post(base_url + "api/auth.php?action=resetpassword", data, {
        headers: {
          Accept: "application/json",
        },
      })
      .then((response) => {
        callback(response.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  //Start Group system Route
  const getChatList = (callback) => {
    let data = new FormData();
    data.append(TokenName, TokenVal);
    data.append("user_id", loginstatus);
    axios({
      method: "POST",
      url: base_url + "Webservices/chatlist",
      data: data,
    })
      .then((response) => {
        callback(response.data, true);
      })
      .catch((error) => {
        callback(error, false);
        console.error("Error fetching data:", error);
      });
  };
  const logout = () => {
    localStorage.removeItem("login");
    localStorage.removeItem("my_refer_code");
    setIsAuthenticated(false);
  };

  return (
    <AuthContext.Provider
      value={{
        TelegramMessageSupport,
        isAuthenticated,
        FSC_KEY_UPDATE,
        TelegramShareLink,
        login,
        Register,
        ForgotPassword,
        GameRule,
        logout,
        base_url,
        app_url,
        app_name,
        getMarkets,
        Bankdata,
        GameChart,
        profile,
        AddMoney,
        WithdrawMoney,
        PromotionData,
        ReferInfo,
        WithdrawalRequest,
        LevelDetail,
        AddBanksCard,
        CancelBet,
        P2PTransferAmount,
        BankCardData,
        TelegramShareMessage,
        SupportContact,
        loginstatus,
        Gameresult,
        Gameinfo,
        Addbet,
        UserGameresult,
        GroupinfoDetail,
        GroupInitiateChat,
        GroupChat,
        Transactiondata,
        sendOTP,
        getChatList,
        GroupAdd,
        Groupinfo
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
